// src/stores/permissionStore.ts
import { defineStore } from 'pinia'
import { fetchUserPermissions } from '@/api/permissions'

export const usePermissionStore = defineStore('permission', {
  state: () => ({
    permissions: [] as string[],
    isLoading: false,
    error: null as string | null,
  }),
  actions: {
    async loadPermissions() {
      this.isLoading = true
      try {
        this.permissions = await fetchUserPermissions()
      } catch (err) {
        console.error('Error fetching permissions:', err)
        this.error = 'Unable to load permissions.'
      } finally {
        this.isLoading = false
      }
    },
    async hasPermission(permission: string): Promise<boolean> {
      if (!this.permissions || this.permissions.length === 0) {
        await this.loadPermissions()
      }
      return this.permissions.includes(permission)
    },
  },
})
